// extracted by mini-css-extract-plugin
export default {"btn":"ButtonLoader_btn__zYy31","loading":"ButtonLoader_loading__9iAUz","loader":"ButtonLoader_loader__y6bDM","spinningColor":"ButtonLoader_spinningColor__MA1XC"};